import React from "react";
import PropTypes from "prop-types";
import { renderCounter } from "./DynamicFieldsHelpers";
import { ICON_SVG } from "../../../constants/iconsvg";

/**
 * Keeps track of the input value. Used to render the counter.
 * @param {*} event Event object of the change
 */
const handleValueChange = (event, input) => {
  input.onChange(event.target.value);
};

/**
 * Renders a text input with appropriate validation.
 * Should be used as a component of a Redux form Field component.
 */
const TextField = ({ input, maxLength, isSensitive, autoFocus, disabled, ...props }) => (
  <div className="relative">
    <input
      id={props.id}
      autoFocus={autoFocus}
      {...input}
      onChange={(e) => handleValueChange(e, input)}
      maxLength={maxLength}
      type={isSensitive != null ? "password" : "text"}
      className="form-control"
      disabled={disabled}
      autoComplete={props.autoComplete || "off"}
    />

    {props.visibilityToggleFunc && (
      <button
        type="button"
        className="password-display-toggle"
        onClick={() => props.visibilityToggleFunc()}
      >
        {props.visibilityToggleValue ? ICON_SVG.FULL_EYE : ICON_SVG.CROSSED_EYE}
      </button>
    )}

    {(!props.visibilityToggleFunc && !props.hideCounter) &&
      renderCounter(maxLength, input.value.length)
    }
  </div>
);

TextField.propTypes = {
  /** The input element */
  input: PropTypes.any,
  /** The maximum length allowed in the text box. */
  maxLength: PropTypes.number,
  isSensitive: PropTypes.bool,
  autoFocus: PropTypes.bool,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  visibilityToggleFunc: PropTypes.func,
  visibilityToggleValue: PropTypes.bool,
  autoComplete: PropTypes.string,
  hideCounter: PropTypes.bool
};

export default TextField;
